import React from 'react';
import { translate } from '../Services/translation';

const addProduct = ({ productId, image, name, onRemove }) => (
  <div key={productId} className="compare-product-item flex flex-col">
    <button
      className="close-button flex items-center justify-center self-end"
      aria-label={`Remove ${name}`}
      onClick={() => {
        onRemove(productId);
      }}
    >
      <span className="icon icon-outlined" aria-hidden="true">close</span>
    </button>
    <img className="product-icon size-28 object-cover border border-border-primary rounded-2xl overflow-clip" src={image} alt={name}></img>
  </div>
);

const CompareProductBlock = (props) => {
  const products =
    props &&
    props.comparedProducts &&
    props.comparedProducts.map((item) =>
      addProduct({
        ...item,
        onRemove: props.onRemove,
      })
    );
  return products && products.length > 0 ? (
    <div className="compare-product-block space-y-3">
      <div className="compare-actions">
        <div className="compare-up-3-product text-text-secondary text-base font-bold">
          {translate('product.compare_up_to_3_product')}
        </div>
        <div>
          <button
            className="remove-all-button underline"
            onClick={() => {
              props.onRemoveAll();
            }}
          >
            {translate('product.remove_all')}
          </button>
        </div>
      </div>
      <div className="compare-products-list flex flex-wrap gap-4">{products}</div>
      <div>
        <a className="hollow inline-block px-4 py-3 text-accent text-sm border border-accent rounded-2xl" href={props.linkToCompareProduct}>
          {translate('product.show_comparison')}
        </a>
      </div>
    </div>
  ) : null;
};

export default CompareProductBlock;
